<mat-card>
  <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
    <mat-card-title>{{ data.title }}</mat-card-title>
    @if (data.hasClose) {
      <button mat-icon-button [mat-dialog-close]="false" class="close-button">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-card-header>

  <div fxLayout="column" fxLayoutAlign="space-between start" fxLayoutGap="30px">
    <mat-card-content class="w-full">
      <mat-form-field
        class="w-full"
        [ngClass]="{ loading: cdnModuleLoadById }"
        appearance="outline"
        [hidden]="!(sourceMode === 'from_cdn_js')"
      >
        <mat-label>CDN JS autocomplete</mat-label>
        <input
          type="text"
          placeholder="Start type lib name"
          aria-label="Cdn module library list"
          matInput
          [matAutocomplete]="cdnModuleAutocomplete"
          #cdnModuleAutocompleteInput
        />
        <mat-autocomplete
          #cdnModuleAutocomplete="matAutocomplete"
          [displayWith]="displayCdnModule"
          class="custom-autocomplete"
        >
          @if (cdnModuleLoading) {
            <mat-option disabled class="loading pt-3 pb-3"> </mat-option>
          }
          @if (noCdnModuleFound()) {
            <mat-option disabled> No module found </mat-option>
          }
          @for (cdnModule of $any(cdnModuleAutocompleteData | async); track cdnModule.name) {
            <mat-option [value]="cdnModule">
              {{ cdnModule.latest }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="w-full"
        [hidden]="!(sourceMode === 'url')"
      >
        <mat-label>Paste direct module url</mat-label>
        <input matInput placeholder="url" #urlInput />
      </mat-form-field>

      <mat-form-field
        class="w-full"
        [ngClass]="{ loading: jsdelivrModuleLoadById }"
        appearance="outline"
        [hidden]="!(sourceMode === 'from_js_delivr')"
      >
        <mat-label>Js Delivr autocomplete</mat-label>
        <input
          type="text"
          placeholder="Start type lib name"
          aria-label="Cdn module library list"
          matInput
          [matAutocomplete]="jsdelivrModuleAutocomplete"
          #jsdelivrModuleAutocompleteInput
        />
        <mat-autocomplete
          #jsdelivrModuleAutocomplete="matAutocomplete"
          [displayWith]="displayJsdelivrModule"
          (optionSelected)="setJsDelivrValue($event)"
          class="custom-autocomplete"
        >
          @if (jsdelivrModuleLoading) {
            <mat-option disabled class="loading pt-3 pb-3"> </mat-option>
          }
          @if (noJsdelivrModuleFound()) {
            <mat-option disabled> No module found </mat-option>
          }
          @for (cdnModule of $any(jsdelivrModuleAutocompleteData | async); track cdnModule.links.self) {
            <mat-option [value]="cdnModule">
              {{ cdnModule.links.self }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field
        class="w-full"
        [ngClass]="{ loading: pyPiModuleLoadById }"
        appearance="outline"
        [hidden]="!(sourceMode === 'py_pi')"
      >
        <mat-label>PyPi autocomplete</mat-label>
        <input
          type="text"
          placeholder="Start type lib name"
          aria-label="Cdn module library list"
          matInput
          [matAutocomplete]="pyPiModuleAutocomplete"
          #pyPiModuleAutocompleteInput
        />
        <mat-autocomplete
          #pyPiModuleAutocomplete="matAutocomplete"
          [displayWith]="displayPyPiModule"
          (optionSelected)="setPyPiValue($event)"
          class="custom-autocomplete"
        >
          @if (pyPiModuleLoading) {
            <mat-option disabled class="loading pt-3 pb-3"> </mat-option>
          }
          @if (noPyPiModuleFound()) {
            <mat-option disabled> No module found </mat-option>
          }
          @for (cdnModule of $any(pyPiModuleAutocompleteData | async); track cdnModule.name) {
            <mat-option [value]="cdnModule">
              {{ cdnModule.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <div>
        <mat-radio-group [(ngModel)]="sourceMode">
          @for (source of sources; track source.value) {
            <mat-radio-button
              [checked]="source.value === sourceMode"
              [value]="source.value"
            >
              {{ source.viewValue }}
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>
    </mat-card-content>

    <mat-card-actions
      fxLayout="row"
      fxLayoutGap="16px"
      [align]="'end'"
      class="w-full p-3"
    >
      @if (data.confirmCaption) {
        <button
          mat-stroked-button
          color="primary"
          class="mr-2"
          (click)="processData()"
        >
          {{ data.confirmCaption }}
        </button>
      }
      @if (data.cancelCaption) {
        <button mat-stroked-button color="warn" [mat-dialog-close]="false">
          {{ data.cancelCaption }}
        </button>
      }
    </mat-card-actions>
  </div>
</mat-card>
